export const EMAIL = "pranav@shikraenergy.in";
export const PHONE = "+91 99270 32865";
export const PHONE_LINK = "tel:+919927032865";
export const MAILTO = `mailto:${EMAIL}?subject=Grid%20optimisation%20inquiry`;
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1756913454966-a90f2b5fc2bd?q=80&w=2400&auto=format&fit=crop";
export const GRID_IMAGE =
  "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?q=80&w=1600&auto=format&fit=crop";
export const EASE = [0.215, 0.61, 0.355, 1];
